var map = {
	"./clock.svg": [
		8994,
		994
	],
	"./facebook-round.svg": [
		2091,
		91
	],
	"./home.svg": [
		9303,
		303
	],
	"./instagram-round.svg": [
		2574,
		574
	],
	"./link.svg": [
		4902,
		902
	],
	"./location.svg": [
		9019,
		19
	],
	"./mail.svg": [
		8690,
		690
	],
	"./phone.svg": [
		7222,
		222
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 8983;
module.exports = webpackAsyncContext;